export { default } from "ember-click-outside-modifier/modifiers/click-outside";
